import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidators {

    static validateLength(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const length = control.value?.length || 0;
            return length >= 8 && length <= 15 ? null : { invalidLength: true };
        };
    }

    static hasSpecialCharacters(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const regex = /[^A-Za-z0-9]/;
            return !regex.test(control.value) ? null : { noSpecialChar: true };
        };
    }

    static hasAscDescCharacters(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const password = control.value || '';
            for (let i = 0; i < password.length - 2; i++) {
                const charCode1 = password.charCodeAt(i);
                const charCode2 = password.charCodeAt(i + 1);
                const charCode3 = password.charCodeAt(i + 2);
                if ((charCode1 + 1 === charCode2 && charCode2 + 1 === charCode3) ||
                    (charCode1 - 1 === charCode2 && charCode2 - 1 === charCode3)) {
                    return { ascDescChars: true };
                }
            }
            return null;
        };
    }

    static hasConsecutiveCharacters(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const regex = /(.)\1\1/;
            return regex.test(control.value) ? { consecutiveChars: true } : null;
        };
    }

    static hasMonexWord(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value.toLowerCase().includes('monex') ? { containsMonex: true } : null;
        };
    }

    static hasUsernameCode(username: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value.toUpperCase().includes(username.toUpperCase()) ? { containsUsername: true } : null;
        };
    }

    static matchConfirmPassword(password: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const confirmPassword = control.value;
            return password === confirmPassword ? null : { passwordMismatch: true };
        };
    }
    static hasUppercaseCharacter(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const regex = /[A-Z]/;
            return regex.test(control.value) ? null : { noUppercase: true };
        };
    }

    static hasNumber(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const regex = /[0-9]/;
            return regex.test(control.value) ? null : { noNumber: true };
        };
    }


}
